import { Injectable } from '@angular/core';
import { HttpService } from '../../utils/services/http.service';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { ErrorsService } from '../../utils/services/errors.service';

@Injectable()
export class MyReportService {
  public subject = new Subject<any>();
  constructor(private httpService: HttpService,
    private errorsService: ErrorsService) { }

  /**API get request to list report */
  getRMReport(empId, startDate, endDate): Observable<any> {
      return this.httpService.get(`project/perUser/${empId}?startDate=${startDate}&endDate=${endDate}`)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**function to error handle requested data */
  handleError(error: any) {
    this.errorsService.handleError(error);
    return Observable.throw(error.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/rm/my-report/my-report.service.ts